import { render } from "./Ttmotif.vue?vue&type=template&id=b582bf54"
import script from "./Ttmotif.vue?vue&type=script&lang=js"
export * from "./Ttmotif.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__